const clickEvent = new MouseEvent('click', { bubbles: true });

export default {
  data() {
    return {
      facets: [],
      hasActiveFacets: false
    };
  },
  methods: {
    clearFacets() {
      document.querySelectorAll('.refined .facet_link').forEach((el) => {
        el.dispatchEvent(clickEvent);
      });
    },
    destroyFacet(facet) {
      facet.removeEventListener('click', this.setClearButtonState);
    },
    initClearFacets() {
      this.facets = Array.from(document.querySelectorAll('.facet_link'));
      this.facets.forEach(this.initFacet);
    },
    initFacet(facet) {
      facet.addEventListener('click', this.setClearButtonState);
    },
    setClearButtonState() {
      this.hasActiveFacets = document.querySelectorAll('li.refined').length > 0;
    }
  },
  created() {
    window.addEventListener('resultsLoaded', this.setClearButtonState);
    window.addEventListener('facetsRendered', this.initClearFacets);
  },
  destroyed() {
    window.removeEventListener('resultsLoaded', this.setClearButtonState);
    window.removeEventListener('facetsRendered', this.initClearFacets);
    this.facets.forEach(this.destroyFacet);
  }
};
